import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import {
    Config,
    isWidget,
} from '@ratehub/base-ui';
import { RefinanceCalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import AdvertisingDisclosure from './AdvertisingDisclosure';
import MortgageSaveToProfileContainer from './MortgageSaveToProfileContainer';


const DATA_NAME_SAVE_TO_PROFILE = 'mtg-refinance-SaveToProfile';

function MortgageRefinanceCalculator({ disclaimer, showAdDisclosure, className, ...otherProps }) {
    const shouldShowSaveToProfileButton = Config.ENABLE_SAVE_TO_PROFILE_BUTTON && !isWidget();

    return (
        <section
            className={classNames(
                'rh-max-width-75',
                'rh-pt-0_5',
            )}
        >
            <If condition={shouldShowSaveToProfileButton}>
                <MortgageSaveToProfileContainer dataName={DATA_NAME_SAVE_TO_PROFILE} />
            </If>
            <RefinanceCalculator
                className={classNames(
                    className,
                    'rh-my-0',
                    'rh-mx-auto',
                )}
                {...otherProps}
            />
            <If condition={showAdDisclosure}>
                <StyledDiv
                    className={classNames(
                        'rh-my-1',
                        'rh-mx-0_5',
                    )}
                >
                    <AdvertisingDisclosure
                        size="extra-small"
                    />
                </StyledDiv>
            </If>
            <If condition={shouldShowSaveToProfileButton}>
                <MortgageSaveToProfileContainer dataName={DATA_NAME_SAVE_TO_PROFILE} />
            </If>
            <If condition={disclaimer}>
                <p
                    className={classNames(
                        'rh-mt-0_25',
                        'rh-mx-0_5',
                        'rh-text-align-center',
                        'rh-text-xs',
                    )}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: disclaimer,
                    }}
                />
            </If>
        </section>
    );
}

MortgageRefinanceCalculator.propTypes = {
    disclaimer: PropTypes.string,
    showAdDisclosure: PropTypes.bool,
    className: PropTypes.string,
};

MortgageRefinanceCalculator.defaultProps = {
    disclaimer: undefined,
    showAdDisclosure: true,
    className: undefined,
};

const StyledDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;

MortgageRefinanceCalculator.blockKey = 'rh/mortgage-refinance-calculator';
MortgageRefinanceCalculator.requiresLayoutRow = true;
MortgageRefinanceCalculator.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsMtg ];

export default MortgageRefinanceCalculator;
